import { render, staticRenderFns } from "./ReportVulnerabilitiesList.vue?vue&type=template&id=97f848d8"
import script from "./ReportVulnerabilitiesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportVulnerabilitiesList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports